"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_valley_bank_ingest = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Valley Bank Ingest`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            vanCust: 'PLACEHOLDER',
            vanCustAcctRel: 'PLACEHOLDER',
            vanDepAcct: 'PLACEHOLDER',
            loanCustRel: 'PLACEHOLDER',
            cuoDeposit: 'PLACEHOLDER',
            collatCustRel: 'PLACEHOLDER',
            cuoCollat: 'PLACEHOLDER',
            psPlusAccount: 'PLACEHOLDER',
            psPlusPortfolio: 'PLACEHOLDER',
            psPlusSecDetail: 'PLACEHOLDER',
            psPlusSecMaster: 'PLACEHOLDER',
            vanCmmt: 'PLACEHOLDER',
            vanLoanAcct: 'PLACEHOLDER',
            vanList: 'PLACEHOLDER',
            vanProduct: 'PLACEHOLDER',
            cuoLoan: 'PLACEHOLDER',
            cuoMaint: 'PLACEHOLDER',
            bloombergMutualFund: 'PLACEHOLDER',
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    return (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: () => true,
        getUINode,
        minInputs: 0,
        maxInputs: 100,
        minOutputs: 0,
        maxOutputs: 100,
    });
};
// validate given IntermediateRecord.
// this is called after initial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ tape, graph, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'valleyBankIngest', `node is not a valleyBankIngest, found: [tape.type:${tape.type}]`);
    const { configuration } = tape;
    const configErrors = [];
    // validate that the input node slugs exist
    const inputIds = (0, utils_1.getInputTapeIds)({ tapeId: tape.id, graph });
    const inputTapeSlugs = new Set();
    inputIds.forEach((tapeId) => {
        const inputTape = (0, utils_1.getTapeById)({ tapeId, graph });
        (0, common_1.finleyAssert)(inputTape, `inputTape must exist for [tapeId:${tapeId}]`);
        inputTapeSlugs.add(inputTape.artifactSlug);
    });
    const seenConfigurationSlugs = new Set();
    // each value should point to input artifact slug
    Object.entries(configuration).forEach(([valleyBankTapeName, inputArtifactSlug]) => {
        if (!inputTapeSlugs.has(inputArtifactSlug)) {
            configErrors.push(`[artifactSlug:${inputArtifactSlug}] for [valleyBankTapeName:${valleyBankTapeName}] does not exist in graph.`);
        }
        if (seenConfigurationSlugs.has(inputArtifactSlug)) {
            configErrors.push(`[artifactSlug:${inputArtifactSlug}] cannot be referenced multiples times in configuration.`);
        }
        else {
            seenConfigurationSlugs.add(inputArtifactSlug);
        }
    });
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_valley_bank_ingest = {
    // what should node say on the tape-builder node creation menu.
    nodeTypeText: 'ValleyBankIngest',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: true,
    // operation nodes dont render badges.
    badgeTexts: ['ValleyBankIngest'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map